module.exports = __webpack_public_path__ + "img/unicuritiba-branco.a75db078.svg";